<template>
  <div class="main-container">
    <home-banner />
    <home-aboutus />
    <home-service />
    <home-video />
    <home-fasilitas />
    <home-news />
    <home-asuransi />
  </div>
</template>

<script>
// Add element Home
import Banner from "../components/home/HomeBanner.vue";
import About from "../components/home/HomeAbout.vue";
import Video from "../components/home/HomeVideo.vue";
import Service from "../components/home/HomeService.vue";
import Fasilitas from "../components/home/HomeFasilitas.vue";
import News from "../components/home/HomeNews.vue";
import Asuransi from "../components/home/HomeAsuransi.vue";
// import { ACTION_SET_LOADING } from "../store/repo/others";

export default {
  components: {
    "home-banner": Banner,
    "home-aboutus": About,
    "home-service": Service,
    "home-fasilitas": Fasilitas,
    "home-news": News,
    "home-asuransi": Asuransi,
    "home-video": Video,
  },
  data() {
    return {
      dir_asset: this.config.dir_asset,
    };
  },
  mounted() {
    // console.log(this.config.dir_asset);
    // this.$store.dispatch(ACTION_SET_LOADING, null);
    // console.log(this.$store.getters.getLoading);
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/Home.vue